export default __webpack_public_path__ + "static/media/rai.eac1aef6.svg";